export const Dock = () => (
  <svg viewBox="0 0 908 792" enableBackground="new 0 0 908 792">
    <path
      stroke="currentColor"
      d="
M764.999939,38.996197
	C779.718689,38.592880 793.778381,39.228260 807.312805,44.367531
	C841.781677,57.456020 863.775757,89.477142 863.805603,127.206795
	C863.871887,211.027863 863.830200,294.848999 863.830139,378.670105
	C863.830017,467.990417 863.882996,557.310791 863.801453,646.631042
	C863.761719,690.143982 835.318115,725.004761 793.027100,733.476196
	C787.840088,734.515259 782.445557,734.937988 777.146973,734.939758
	C554.512878,735.013000 331.878815,735.033997 109.244728,734.986267
	C60.468105,734.975830 22.258093,696.424194 22.208084,647.028809
	C22.091845,532.212341 22.169842,417.395721 22.169313,302.579132
	C22.169043,243.921021 21.909054,185.261307 22.269880,126.605423
	C22.475704,93.146690 37.423141,67.517761 66.201942,50.342770
	C79.476074,42.420860 94.104118,38.972561 109.594513,38.974560
	C327.896332,39.002731 546.198181,38.996384 764.999939,38.996197
M609.500366,224.447906
	C424.113251,224.447906 238.726135,224.447906 53.041370,224.447906
	C53.041370,226.120529 53.041374,227.099823 53.041374,228.079117
	C53.041313,367.729126 53.000885,507.379181 53.070850,647.029175
	C53.087406,680.078064 77.446625,704.104980 110.769684,704.109863
	C332.243500,704.141968 553.717285,704.137268 775.191101,704.059448
	C780.307556,704.057678 785.574646,703.659241 790.514648,702.420959
	C816.472900,695.914429 832.945251,673.916931 832.949524,646.067261
	C832.970886,507.250488 832.958923,368.433685 832.958679,229.616913
	C832.958679,227.989944 832.958618,226.362961 832.958618,224.447784
	C758.458252,224.447784 684.479370,224.447784 609.500366,224.447906
M385.500031,69.871887
	C294.022614,69.872368 202.545197,69.863350 111.067780,69.878265
	C77.237923,69.883781 53.097054,93.925919 53.045517,127.638184
	C53.014698,147.799759 53.039730,167.961441 53.039665,188.123077
	C53.039658,189.885620 53.039665,191.648163 53.039665,193.410446
	C313.363037,193.410446 573.033203,193.410446 832.960022,193.410446
	C832.960022,171.918777 832.965576,150.769867 832.952942,129.620972
	C832.951355,126.956017 833.004578,124.277084 832.759033,121.629982
	C832.498657,118.823303 832.092590,116.003883 831.439941,113.263908
	C825.151306,86.863632 803.315063,69.902954 775.403320,69.895241
	C645.768921,69.859436 516.134460,69.874825 385.500031,69.871887
z"
    />
    <path
      stroke="currentColor"
      d="
M745.940186,632.819824
	C542.669495,632.819824 339.888824,632.819946 137.108170,632.820190
	C136.275055,632.820190 135.441620,632.837830 134.608871,632.820984
	C124.923660,632.625244 117.967690,626.083801 118.007660,617.215027
	C118.047661,608.338074 125.004074,601.972290 134.804489,601.970642
	C230.946060,601.954651 327.087646,601.953857 423.229218,601.953857
	C532.034119,601.953918 640.839050,601.957092 749.643982,601.977478
	C751.798096,601.977905 754.023438,601.901001 756.093445,602.383728
	C763.410889,604.089966 768.410278,610.871948 767.981384,618.169006
	C767.528931,625.867065 761.503601,631.960815 753.424194,632.729614
	C751.110962,632.949646 748.762573,632.800049 745.940186,632.819824
z"
    />
  </svg>
);
